import { useCallback, useState } from "react";
import Model, { Providers } from "@tripian/model";
import { providers } from "@tripian/core";

const useToristyInfo = () => {
  const [loadingToristyInfo, setLoadingToristyInfo] = useState<boolean>(false);
  const [toristyInfo, setToristyInfo] =
    useState<Providers.Toristy.ProductDetailsResponse>();
  const [toristyInfoFailed, setToristyInfoFailed] = useState<boolean>(false);

  const fetchToristyInfo = useCallback(
    (productCode: string): Promise<Boolean> => {
      if (
        providers.toristy &&
        window.tconfig.SHOW_TOURS_AND_TICKETS &&
        window.tconfig.TOUR_TICKET_PROVIDER_IDS.some(
          x => x === Model.PROVIDER_ID.TORISTY
        )
      ) {
        setLoadingToristyInfo(true);
        setToristyInfo(undefined);
        setToristyInfoFailed(false);

        return providers.toristy
          .serviceDetails(productCode)
          .then((data: Providers.Toristy.ProductDetailsResponse) => {
            setToristyInfo(data);
            return true;
          })
          .catch(() => {
            // The detail page shows this failure inline, so no toast here
            setToristyInfoFailed(true);
            setLoadingToristyInfo(false);
            return false;
          })
          .finally(() => {
            setLoadingToristyInfo(false);
          });
      }
      return Promise.resolve(false);
    },
    []
  );

  return {
    fetchToristyInfo,
    loadingToristyInfo,
    toristyInfo,
    toristyInfoFailed,
  };
};

export default useToristyInfo;
